import { render } from "./ServicesCard.vue?vue&type=template&id=2e7dfc23"
import script from "./ServicesCard.vue?vue&type=script&lang=js"
export * from "./ServicesCard.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/digiasia.asia.bak/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__